import { createFileRoute } from '@tanstack/react-router'
import SetPasswordIndex from '@/pages/auth/set-password'

export const Route = createFileRoute('/_auth/auth/set-password')({
  component: SetPasswordIndex,
})
